import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { MarketStore } from "@faire/retailer-visitor-shared/stores/domain/Events/FaireMarkets/MarketStore";
import { Button } from "@faire/web--source/slate/Button";
import { Column } from "@faire/web--source/slate/Layout";
import { getSpacing, Spacer } from "@faire/web--source/slate/spacing";
import { FaireMarketTheme } from "@faire/web--source/slate/Theme/EventsTheme";
import { getEventTheme } from "@faire/web--source/slate/Theme/eventsThemeColors";
import { EventsThemeShapeCombination } from "@faire/web--source/slate/Theme/EventsThemeShapeCombination";
import { responsiveMediaQueries } from "@faire/web--source/slate/Theme/responsiveMediaQueries";
import { ThemeProvider } from "@faire/web--source/slate/Theme/ThemeProvider";
import { Typography } from "@faire/web--source/slate/Typography";
import { StrictLocalMsg } from "@faire/web--source/ui/lib/localization";
import { ResponsiveContentV2 } from "@faire/web--source/ui/ResponsiveContentV2";
import marketsAllSpecials from "@faire/web-api--source/routes/www/markets/event_type/all-specials";
import React from "react";
import styled from "styled-components";
export var HomeFaireMarketFooter = function(param) {
    var onClick = param.onClick;
    var _getEventTheme_decorative5, _getEventTheme_decorative6, _getEventTheme_decorative51, _getEventTheme_decorative61;
    return /*#__PURE__*/ _jsxs(FullWidthWrapper, {
        children: [
            /*#__PURE__*/ _jsx(ResponsiveContentV2, {
                tabletAndAbove: /*#__PURE__*/ _jsx(StyledMarketPrimaryTertiaryShapes, {
                    width: "510px",
                    height: "321px",
                    backShapeColor: (_getEventTheme_decorative5 = getEventTheme("faireMarket").decorative5) !== null && _getEventTheme_decorative5 !== void 0 ? _getEventTheme_decorative5 : "",
                    frontShapeColor: (_getEventTheme_decorative6 = getEventTheme("faireMarket").decorative6) !== null && _getEventTheme_decorative6 !== void 0 ? _getEventTheme_decorative6 : ""
                }),
                mobile: /*#__PURE__*/ _jsx(StyledMarketPrimaryTertiaryShapes, {
                    width: "238px",
                    height: "150px",
                    backShapeColor: (_getEventTheme_decorative51 = getEventTheme("faireMarket").decorative5) !== null && _getEventTheme_decorative51 !== void 0 ? _getEventTheme_decorative51 : "",
                    frontShapeColor: (_getEventTheme_decorative61 = getEventTheme("faireMarket").decorative6) !== null && _getEventTheme_decorative61 !== void 0 ? _getEventTheme_decorative61 : ""
                })
            }),
            /*#__PURE__*/ _jsxs(Wrapper, {
                children: [
                    /*#__PURE__*/ _jsx(FooterText, {
                        variant: {
                            mobileAndAbove: "displaySSerifRegular",
                            tabletAndAbove: "displayMSerifRegular"
                        },
                        children: /*#__PURE__*/ _jsx(StrictLocalMsg, {
                            id: "a8bmhI",
                            defaultMessage: [
                                {
                                    type: 0,
                                    value: "Shop thousands of market specials before they\u2019re gone!"
                                }
                            ]
                        })
                    }),
                    /*#__PURE__*/ _jsx(Spacer, {
                        size: "4x"
                    }),
                    /*#__PURE__*/ _jsx(ThemeProvider, {
                        theme: FaireMarketTheme,
                        children: /*#__PURE__*/ _jsx(StyledButton, {
                            linkTo: marketsAllSpecials(MarketStore.get().currentEventType),
                            onClick: onClick,
                            children: /*#__PURE__*/ _jsx(StrictLocalMsg, {
                                id: "d8ZJG6",
                                defaultMessage: [
                                    {
                                        type: 0,
                                        value: "Browse participating brands"
                                    }
                                ]
                            })
                        })
                    })
                ]
            })
        ]
    });
};
var FullWidthWrapper = styled.div.withConfig({
    componentId: "sc-a4655b0a-0"
})([
    "position:relative;background-color:",
    ";overflow:hidden;"
], getEventTheme("faireMarket").primaryDark);
var Wrapper = styled(Column).withConfig({
    componentId: "sc-a4655b0a-1"
})([
    "position:relative;padding:",
    ";margin:0 auto;max-width:1280px;",
    "{padding:",
    ";}",
    "{padding:",
    ";}"
], getSpacing("8x", "7x"), responsiveMediaQueries.tablet, getSpacing("6x", "7x"), responsiveMediaQueries.mobile, getSpacing("4x", "3x"));
var FooterText = styled(Typography).attrs({
    color: getEventTheme("faireMarket").promoTextInverse
}).withConfig({
    componentId: "sc-a4655b0a-2"
})([
    "&&&{margin-right:464px;",
    "{margin-right:260px;}",
    "{margin-right:",
    ";}}"
], responsiveMediaQueries.tablet, responsiveMediaQueries.mobile, getSpacing("7x"));
var StyledButton = styled(Button).attrs({
    variant: "secondary"
}).withConfig({
    componentId: "sc-a4655b0a-3"
})([
    "width:fit-content;border:0;"
]);
var StyledMarketPrimaryTertiaryShapes = styled(EventsThemeShapeCombination.faireMarket.comboC).withConfig({
    componentId: "sc-a4655b0a-4"
})([
    "position:absolute;right:-91px;bottom:-38px;",
    "{right:-44px;bottom:-17px;}"
], responsiveMediaQueries.mobile);
